import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
let SegmentAnalyticsMixin = class SegmentAnalyticsMixin extends Vue {
    /**
     * Segment Analytics Identify Event
     * @author Johsua Timario <johsua@gorated.ph>
     * @since Version {0.29.1}
     *
     * Reference: https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/#identify
     */
    segmentIdentify(userId, content = {}) {
        this.$segment.identify(userId, content);
    }
    /**
     * Segment Analytics Track Event
     * @author Johsua Timario <johsua@gorated.ph>
     * @since Version {0.29.1}
     *
     * Reference: https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/#track
     */
    segmentTrack(eventName, content = {}) {
        this.$segment.track(eventName, content);
    }
    /**
     * Segment Analytics Page Event
     * @author Johsua Timario <johsua@gorated.ph>
     * @since Version {0.29.1}
     *
     * Reference: https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/#page
     */
    segmentPage(page, content = {}) {
        this.$segment.page(page, content);
    }
};
SegmentAnalyticsMixin = __decorate([
    Component
], SegmentAnalyticsMixin);
export default SegmentAnalyticsMixin;
